module.exports = {
	init() {
		if (this.root.parentNode.classList.contains('square-layout')) {
			this.root.parentNode.classList.remove('square-layout');
		}
	},
};
